import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "./ui/button";

export default function LegalLayout({ title, lastUpdate, children }) {
  return (
    <main className="relative bg-white min-h-screen">
      <div className="relative max-w-4xl mx-auto px-5 md:px-8 pt-10 pb-20">
        <Link to="/">
          <Button variant="ghost" className="text-[#102a6b] hover:bg-[#102a6b]/5 hover:text-[#0a1f55] -ml-2">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Torna alla home
          </Button>
        </Link>

        <header className="mt-6 pb-8 border-b border-slate-200">
          <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#f59e0b]">
            Documento Legale
          </div>
          <h1 className="mt-3 text-3xl md:text-5xl font-extrabold text-[#0a1f55] leading-[1.1]">
            {title}
          </h1>
          {lastUpdate && (
            <p className="mt-3 text-sm text-slate-500">Ultimo aggiornamento: {lastUpdate}</p>
          )}
        </header>

        <article className="prose-acdt mt-10">{children}</article>
      </div>
    </main>
  );
}
